import { render, staticRenderFns } from "./MyPageCompetition.vue?vue&type=template&id=03252080&scoped=true"
import script from "./MyPageCompetition.vue?vue&type=script&lang=js"
export * from "./MyPageCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03252080",
  null
  
)

export default component.exports